import Company from "./views/company/Company.vue";


export default {
	router: [
		{
			path: "/finance/bank_report",
			name: "finance_bank_report",
			component: Company,
		},
		{
			path: "/finance/client_mandate",
			name: "finance_client_mandate",
			component: Company,
		},
		{
			path: "/finance/payment",
			name: "finance_payment",
			component: Company,
		},
		{
			path: "/finance/account",
			name: "finance_account",
			component: Company,
		},
	]
}